import { render } from "./WishlistRow.vue?vue&type=template&id=6a01e643"
import script from "./WishlistRow.vue?vue&type=script&lang=js"
export * from "./WishlistRow.vue?vue&type=script&lang=js"

import "./WishlistRow.vue?vue&type=style&index=0&id=6a01e643&lang=css"
script.render = render

export default script